import React, { useEffect } from "react";
import { Table } from "react-bootstrap";
import { Trans, useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";

import { useAppApi } from "@/App";
import { DeveloperLnkPublisherStateDisplay } from "@components/Displays/PublisherStateDisplay";
import { DevForm } from "@components/Forms/Fields";
import { RenderForm } from "@components/Forms/Render";
import { Awesome } from "@components/Helpers";
import { CommonCard, ListingCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function PublishersGamedevs(props) {
    const params = useParams();
    return params.id ? <Add {...props} /> : <List {...props} />;
}

function List({ screen, developerId, header }) {
    let apiPath = "api:developer:publisher:list";
    let addPath = "devs:publishers:add";
    if (screen === "gamedevs") {
        apiPath = "api:developer:gamedev:list";
        addPath = "devs:gamedevs:add";
    }
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse(apiPath, { developer_id: developerId }));

    if (!apiData) return;

    const btn_disabled = apiData.can_add === true ? "" : "disabled";
    const headerTools = (
        <Link to={url_reverse(addPath, { dev_id: developerId })} className={`btn btn-sm btn-dark ${btn_disabled}`}>
            <Awesome type="plus-circle" /> {t("Добавить")}
        </Link>
    );

    return (
        <ListingCard header={header} headerTools={headerTools}>
            <div className="dmg-callout dmg-callout-info">
                {screen === "publishers" && (
                    <Trans>
                        Этот раздел предназначен для добавления и управления данными издателей игр, которые могут быть
                        отображены на карточке игры. Перед тем как добавить новое название, пожалуйста, ознакомьтесь с
                        текущим списком издателей. Возможно, нужное название уже имеется в справочнике.
                    </Trans>
                )}
                {screen === "gamedevs" && (
                    <Trans>
                        Этот раздел предназначен для добавления и управления данными разработчиков игр, которые могут
                        быть отображены на карточке игры. Перед тем как добавить новое название, пожалуйста,
                        ознакомьтесь с текущим списком разработчиков. Возможно, нужное название уже имеется в
                        справочнике.
                    </Trans>
                )}
            </div>
            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th>{t("Название")}</th>
                        <th>{t("Статус")}</th>
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((obj) => (
                        <tr key={`object_list${obj.id}`}>
                            <td>{obj.publisher.name}</td>
                            <td>
                                <DeveloperLnkPublisherStateDisplay lnk={obj} />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </ListingCard>
    );
}

function Add({ screen, developerId, header }) {
    let apiPath = "api:developer:publisher:add";
    let listPath = "devs:publishers";
    if (screen === "gamedevs") {
        apiPath = "api:developer:gamedev:add";
        listPath = "devs:gamedevs";
    }
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse(apiPath, { developer_id: developerId }));
    const navigate = useNavigate();

    useEffect(() => {
        if (apiData?.can_add === false) {
            navigate(url_reverse(listPath, { dev_id: developerId }));
        }
    }, [apiData]);

    if (!apiData) return;

    const buttons = (
        <DevForm.Button variant="warning" type="submit" name="action_form" value="main">
            {t("Отправить на модерацию")}
        </DevForm.Button>
    );
    return (
        <CommonCard header={header}>
            <RenderForm backUrl={url_reverse(listPath, { dev_id: developerId })} buttons={buttons} />
        </CommonCard>
    );
}
